import Alpine from 'alpinejs';
import { DeviceStore } from './device_detect';

export const getDeviceStore = (): DeviceStore => {
    if (!Alpine.store('device')) {
        Alpine.store('device', new DeviceStore());
    }

    return Alpine.store('device') as DeviceStore;
};
